module.exports = __webpack_public_path__ + "media/images/annotator-glyph-sprite-81adc495d5d27f07ce246819155f0882.png";